import { RouteConfig } from 'vue-router';
import { RouterPath } from '../shared/enums';
import { Role } from '../shared/enums/role.enum';

export default (): Array<RouteConfig> => {
    return [
        {
            path: RouterPath.DASHBOARD,
            name: 'Evolução das vendas',
            meta: {role: Role.DASHBOARD},
            component: () => import('./components/pages/page-dashboard').then(m => m.default),
            alias: 'Dashboard'
        },
        {
            path: RouterPath.DASHBOARD_DETAILS,
            name: 'Trechos',
            meta: {role: Role.DASHBOARD},
            component: () => import('./components/pages/dashboard-details').then(m => m.default),
            alias: 'Dashboard details'
        },
    ];
};
